module.exports = __webpack_public_path__ + "static/media/Demo video.baf1d206.MOV";